import React, { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FaBookOpen, FaSearch } from 'react-icons/fa';

function VolumesIssues() {
  const [volumes, setVolumes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedJournal, setSelectedJournal] = useState('');
  const [search, setSearch] = useState('');
  const journalTypes = Array.from(new Set(volumes.map(v => v.journal_type)));

  useEffect(() => {
    async function fetchVolumes() {
      setLoading(true);
      const { data, error } = await supabase
        .from('volumes')
        .select('volume_number, year, journal_type')
        .order('volume_number', { ascending: false });
      if (!error && data) {
        // Combine by volume_number, year, journal_type
        const unique = [];
        const seen = new Set();
        for (const v of data) {
          const key = `${v.volume_number}_${v.year}_${v.journal_type}`;
          if (!seen.has(key)) {
            unique.push(v);
            seen.add(key);
          }
        }
        setVolumes(unique);
      }
      setLoading(false);
    }
    fetchVolumes();
  }, []);

  const filteredVolumes = volumes.filter(v => {
    const matchesJournal = !selectedJournal || v.journal_type === selectedJournal;
    const matchesSearch =
      search === '' ||
      v.year.toString().includes(search) ||
      v.volume_number.toString().includes(search);
    return matchesJournal && matchesSearch;
  });

  return (
    <div className="volumes-issues-page">
      <Helmet>
        <title>Volumes & Issues - darsgah-e-ahlebait</title>
        <meta name="description" content="Browse volumes and issues of darsgah-e-ahlebait journals." />
      </Helmet>
      <h2 className="mb-4 text-center">Volumes & Issues</h2>
      <div className="mb-4 d-flex flex-wrap justify-content-center align-items-center gap-3">
        <div className="d-flex align-items-center bg-white rounded shadow-sm px-3 py-2">
          <label htmlFor="journalType" className="form-label mb-0 me-2 fw-bold text-primary">Filter by Journal:</label>
          <select id="journalType" className="form-select w-auto border-0 bg-light" style={{minWidth: 120}} value={selectedJournal} onChange={e => setSelectedJournal(e.target.value)}>
            <option value="">All</option>
            {journalTypes.map(jt => (
              <option key={jt} value={jt}>{jt.toUpperCase()}</option>
            ))}
          </select>
        </div>
        <div className="d-flex align-items-center bg-white rounded shadow-sm px-3 py-2">
          <FaSearch className="me-2 text-secondary" />
          <input
            type="text"
            className="form-control border-0 bg-light"
            style={{minWidth: 180}}
            placeholder="Search by year or volume..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>
      </div>
      {loading ? (
        <div className="text-center my-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="row g-4 justify-content-center">
          {filteredVolumes.length === 0 ? (
            <div className="text-center text-muted">No volumes found.</div>
          ) : filteredVolumes.map(volume => (
            <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={`${volume.volume_number}_${volume.year}_${volume.journal_type}`}>
              <Link to={`/volume-issues/${volume.volume_number}/${volume.year}/${volume.journal_type}`} className="text-decoration-none">
                <div className="card h-100 shadow-lg border-0 volume-card position-relative overflow-hidden" style={{borderRadius: '1.2rem', background: 'linear-gradient(135deg, #e0e7ff 0%, #f0fdfa 100%)'}}>
                  <div className="card-body d-flex flex-column align-items-center justify-content-center py-5">
                    <FaBookOpen size={48} className="mb-3 text-primary" />
                    <h4 className="card-title mb-2 fw-bold text-dark">Volume {volume.volume_number}</h4>
                    <div className="mb-1 text-secondary">({volume.year})</div>
                    <div className="mb-2"><span className="badge bg-primary bg-opacity-10 text-primary fw-normal">{volume.journal_type.toUpperCase()}</span></div>
                  </div>
                  <div className="volume-card-hover position-absolute top-0 start-0 w-100 h-100" style={{background: 'rgba(0,123,255,0.08)', opacity: 0, transition: 'opacity 0.3s'}}></div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      )}
      <style>{`
        .volume-card:hover .volume-card-hover {
          opacity: 1;
        }
        .volume-card:hover {
          transform: translateY(-6px) scale(1.03);
          box-shadow: 0 8px 32px rgba(0,0,0,0.12);
        }
        .volume-card {
          transition: box-shadow 0.3s, transform 0.3s;
        }
      `}</style>
    </div>
  );
}

export default VolumesIssues; 